import { authorizedInstance } from "../config/axios"

export const generateQRCodeForTwoFa = async () => {
  const response = await authorizedInstance.get("/two-fa/generate-qr-code")
  return response.data
}

export const verifyOTPForTwoFa = async (payload) => {
  const response = await authorizedInstance.post("/two-fa/verify-otp", payload)
  return response.data
}
